import React from "react";

const MessageInputContext = React.createContext({
  value: {},
  update: () => {}
});

export default MessageInputContext;
